module.exports = __webpack_public_path__ + "87a076a9e6951cc454803d4fe0e2563e.png";